import { TwSolicitudJerarquiaViewModel } from '../datosbasicos/datosbasicos.types';
import { UsuarioViewModel } from '../../../_mantenimiento/usuarios/usuarios.types';

export class SolicitudDocumentosViewModel {
    public Id: number;
    public IdEstadoSolicitud = 0;
    public IdEstadoSolicitudDescripcion: string;
    public IdTipoSolicitud: number;
    public IdTipoSolicitudDescripcion: string;
    public IdEstadoChedPp: number | null;
    public IdEstadoChedPpDescripcion: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public EsPredua: boolean;
    public EsPrevia: boolean;
    public EsReImportacion: boolean;
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
    public TDocumentoSolicitudCollection: TDocumentoSolicitudViewModel[];
}

export class TDocumentoSolicitudViewModel {
    public Id: number;
    public IdSolicitud: number;
    public IdTipoDocumentacion: number;
    public IdTipoDocumentacionDescripcion: string;
    public Texto = '';
    public Fecha: Date | null = null;
    public IdPais: number | null = null;
    public IdPaisDescripcion: string;
    public CodigoStorage = '';
    public OldCodigoStorageCollection: string[] = [];
    public NombreArchivo = '';
    public Size: number | null = null;
    public VisibleInspector: boolean | null = false;
    public IdEstadoSolicitud = 0;
    public IdEstadoSolicitudDescripcion: string;
    public IdTipoSolicitud: number;
    public IdTipoSolicitudDescripcion: string;
    public IdEstadoChedPp: number | null;
    public IdEstadoChedPpDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public EsPredua: boolean;
    public EsPrevia: boolean;
    public EsReImportacion: boolean;
    public ReferenciaTraces: string | null;
    public DocumentDownloadedFromTraces = false;
    public AttachedRechazo: boolean;
    public FechaCreacion: Date;
    public Perfil: string;
    public IdUsuario: number | null;
    public Revisado: boolean;
    public SubidoPorInspector: boolean;
    public DeRechazoParcial: boolean;
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
}

export class GenericPostDownloadPdfTracesRequest {
    public Reference: string;
    public issuingNppoCountryID: string;
}

//igual al del componente de subida de ficheros en Documentos, pero para descargar desde Traces (phyto y ephyto)
export class DownloadedFileViewModel {
    constructor() {
        this.OldGuidCollection = new Array<string>();
    }

    public Name = '';

    public Size: number;

    public Progress: number;

    public Guid: string;

    public OldGuidCollection: string[];

    public MarkToDelete = false;
}
